module.exports = __webpack_public_path__ + "static/media/worq.baa53af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/worq.png
// module id = 182
// module chunks = 0